import { AbstractControl, ValidatorFn } from '@angular/forms';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';

export function phoneNumberValidator(countryCode: CountryCode): ValidatorFn {
  return (control: AbstractControl): { invalidPhoneNumber: boolean } | null => {
    const phoneNumber = control.value;

    if (!phoneNumber || isValidPhoneNumber(phoneNumber, countryCode)) {
      return null;
    }

    return { invalidPhoneNumber: true };
  };
}
